/**
 * Hover guidance for the product set editor (PLT-7027): short instructions shown in tooltips on the
 * toolbar buttons, the "Revenue or %" column header and the edit dialog, so users don't need the
 * input data documentation for the basics. Copy from Delivery (Matleena).
 *
 * The attribute sections' own guidance, and the Advanced attributes tab's, is in
 * `ipr/attribute-guidance.ts`, which the chat reads too (PLT-7430).
 */
export const INPUT_GUIDANCE = {
  addSegment: 'Add a group to organise your products, e.g. by business area or product line.',
  addProduct:
    'Add a product or service that generates revenue. A clear, specific description helps us match it correctly.',
  // Empty rows don't reliably get an even share of the remainder (`resolveRelativeProductWeights`
  // only splits what's left below 1), so the copy asks for every product to be filled in.
  revenue:
    'Enter revenue or a % share for each product. Estimates are fine. Use the same unit for every product and fill in all of them, as we scale the values to add up to 100%.',
  attributes:
    'Add details that make this product different from a standard product of its type, such as recyclability, energy use or certificates. They help us assess its impacts more accurately.',
};
